import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagTC = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25C0 25.006 25 .003 25 0c13.807 0 25 11.193 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M24.932 25H25v-.067a10.55 10.55 0 0 1-.067.067Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 13.043V0h-.004C11.19.002 0 11.194 0 25h13.043v-7.345L20.389 25h4.545l.067-.067V20.39l-7.345-7.345H25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M12.649 3.26a25.119 25.119 0 0 0-9.387 9.388V25h6.521V9.783h15.218V3.26H12.649Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m25.001 21.925-8.882-8.882h-3.074L25 25v-3.075Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M28.262 13.044V25c0 5.824 7.608 7.609 7.608 7.609s7.61-1.785 7.61-7.609V13.044H28.261Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FF9811",
  d: "M34.782 17.392c0 1.2-.973 4.347-2.174 4.347-1.2 0-2.174-3.147-2.174-4.348 0-1.2 2.174-2.173 2.174-2.173s2.174.973 2.174 2.174Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M40.552 19.76c.35-.857.623-2.108.623-2.73 0-1.001-1.304-1.812-1.304-1.812s-1.304.81-1.304 1.811c0 .623.273 1.874.623 2.73l-.753 1.7a3.8 3.8 0 0 0 2.868 0l-.753-1.7Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M34.24 25s-1.087 2.174-1.087 4.348h5.435c0-2.174-1.087-4.348-1.087-4.348l-1.63-1.087L34.24 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M37.5 25v-.544a1.63 1.63 0 0 0-3.262 0V25H37.5Z"
}));
FlagTC.displayName = 'FlagTC';
export default withFlagWrapper(FlagTC);
//# sourceMappingURL=index.js.map